import React, { useEffect, useMemo, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import Select from "react-select";
import countryList from "react-select-country-list";
import { toast } from "react-hot-toast";
import dist1 from "../../assets/images/categ1.png";
import "../../assets/styles/distributors.css";
import "../../assets/styles/createproduct.css";
import { useUpdateDistributorUser } from "../../hooks/distributor/distributor.user.edit";
import { useViewSingleDistributorUser } from "../../hooks/distributor/distributer.user.viewbyid";

const EditUsers = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { id: routeUserId } = useParams();
  const { userId: stateUserId, distributorId } = location.state || {};
  const userId = routeUserId || stateUserId || distributorId;

  const countryOptions = useMemo(() => countryList().getData(), []);
  const { data: userData, isLoading } = useViewSingleDistributorUser(userId);
  const { mutate: updateDistributorUser, isPending } = useUpdateDistributorUser();

  const [form, setForm] = useState({
    contactPerson: "",
    email: "",
    phone: "",
    designation: "",
    country: null,
    accessStatus: "active",
    profilePicture: null,
    verificationIntervalDays: 60,

  });
  const [imagePreview, setImagePreview] = useState(dist1);

  useEffect(() => {
    const user = userData?.data;
    if (!user) return;

    const savedCountry =
      countryOptions.find(
        (option) => option.label === user.country || option.value === user.country
      ) || null;

    setForm({
      contactPerson: user.contactPerson || "",
      email: user.email || "",
      phone: user.phone || "",
      designation: user.designation || "",
      country: savedCountry,
      accessStatus: user.accessStatus || "active",
      profilePicture: null,
      verificationIntervalDays: user.verificationIntervalDays || 60,
    });

    if (user.profilePicture) {
      setImagePreview(
        user.profilePicture.startsWith("http")
          ? user.profilePicture
          : `${process.env.REACT_APP_BASE_IMAGE}/${user.profilePicture}`
      );
    } else {
      setImagePreview(dist1);
    }
  }, [userData, countryOptions]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleImageChange = (input) => {
    if (input.files && input.files[0]) {
      const file = input.files[0];
      const reader = new FileReader();
      reader.onload = function (e) {
        setImagePreview(e.target.result);
      };
      reader.readAsDataURL(file);
      setForm((prev) => ({ ...prev, profilePicture: file }));
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!userId) {
      toast.error("Distributor user ID is missing.");
      return;
    }

    if (!form.contactPerson.trim() || !form.email.trim() || !form.phone.trim()) {
      toast.error("Please fill contact person, email, and phone.");
      return;
    }

    const body = new FormData();
    body.append("contactPerson", form.contactPerson.trim());
    body.append("email", form.email.trim());
    body.append("phone", form.phone.trim());
    body.append("designation", form.designation.trim());
    body.append("country", form.country?.label || "");
    body.append("accessStatus", form.accessStatus);
    body.append('otpVerification[verificationIntervalDays]', form.verificationIntervalDays);


    if (form.profilePicture) {
      body.append("profilePicture", form.profilePicture);
    }

    updateDistributorUser(
      { id: userId, body },
      {
        onSuccess: () => {
          toast.success("Distributor user updated successfully!");
          navigate(-1);
        },
        onError: (error) => {
          toast.error(
            error?.response?.data?.message || "Failed to update distributor user."
          );
        },
      }
    );
  };

  if (!userId) {
    return (
      <div className="body">
        <div style={{ color: "#dc3545", padding: "20px" }}>
          Distributor user not found. Please open edit from the distributor view page.
        </div>
      </div>
    );
  }

  if (isLoading) {
    return (
      <div className="body" style={{ textAlign: "center", padding: "40px 20px", color: "#888" }}>
        Loading distributor user...
      </div>
    );
  }

  return (
    <div className="body">
      <div className="inputFields">
        <div className="distributors">
          <form onSubmit={handleSubmit}>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginBottom: "20px",
              }}
            >
              <h3 style={{ margin: 0, color: "#004996" }}>Edit Distributor User</h3>
              <button
                type="button"
                className="commonButton"
                style={{ background: "#6c757d" }}
                onClick={() => navigate(-1)}
              >
                Back
              </button>
            </div>

            <div
              style={{
                background: "#fff",
                padding: "20px",
                borderRadius: "8px",
                border: "1px solid #d9e3f0",
              }}
            >
              <div className="form-headerr">
                <div className="image-upload-section">
                  <label style={{ fontWeight: "bold", marginBottom: "10px", display: "block" }}>
                    Upload Profile Picture:
                  </label>
                  <div className="avatar-upload" style={{ margin: "0" }}>
                    <div className="avatar-edit">
                      <input
                        type="file"
                        id="editDistributorUserImageUpload"
                        accept=".png, .jpg, .jpeg"
                        onChange={(e) => handleImageChange(e.target)}
                      />
                      <label htmlFor="editDistributorUserImageUpload"></label>
                    </div>
                    <div className="avatar-preview">
                      <div
                        id="editDistributorUserImagePreview"
                        style={{ backgroundImage: `url(${imagePreview})` }}
                      ></div>
                    </div>
                  </div>
                </div>

                <div className="name">
                  <label style={{ fontWeight: "bold" }}>
                    Contact Person Name <span style={{ color: "red" }}>*</span>
                  </label>
                  <input
                    type="text"
                    name="contactPerson"
                    value={form.contactPerson}
                    onChange={handleInputChange}
                    placeholder="Enter full name..."
                    required
                    style={{ width: "100%", marginTop: "10px", padding: "12px" }}
                  />
                </div>

                <div className="name">
                  <label style={{ fontWeight: "bold" }}>
                    Email <span style={{ color: "red" }}>*</span>
                  </label>
                  <input
                    type="email"
                    name="email"
                    value={form.email}
                    onChange={handleInputChange}
                    placeholder="Enter email address..."
                    required
                    style={{ width: "100%", marginTop: "10px", padding: "12px" }}
                  />
                </div>

                <div className="name">
                  <label style={{ fontWeight: "bold" }}>
                    Phone <span style={{ color: "red" }}>*</span>
                  </label>
                  <input
                    type="tel"
                    name="phone"
                    value={form.phone}
                    onChange={handleInputChange}
                    placeholder="Enter phone number..."
                    required
                    style={{ width: "100%", marginTop: "10px", padding: "12px" }}
                  />
                </div>

                <div className="name">
                  <label style={{ fontWeight: "bold" }}>Designation</label>
                  <input
                    type="text"
                    name="designation"
                    value={form.designation}
                    onChange={handleInputChange}
                    placeholder="Enter designation..."
                    style={{ width: "100%", marginTop: "10px", padding: "12px" }}
                  />
                </div>

                <div className="name">
                  <label style={{ fontWeight: "bold" }}>Country</label>
                  <Select
                    options={countryOptions}
                    value={form.country}
                    onChange={(value) => setForm((prev) => ({ ...prev, country: value }))}
                    placeholder="Select country..."
                    styles={{
                      control: (base) => ({
                        ...base,
                        marginTop: "10px",
                        padding: "4px",
                      }),
                    }}
                    isClearable
                  />
                </div>

                <div className="name">
                  <label style={{ fontWeight: "bold" }}>accessStatus</label>
                  <select
                    name="accessStatus"
                    value={form.accessStatus}
                    onChange={handleInputChange}
                    style={{
                      width: "100%",
                      marginTop: "10px",
                      padding: "15px",
                      borderRadius: "6px",
                      border: "1px solid #d9d9d9",
                      backgroundColor: "#fff",
                    }}
                  >
                    <option value="active">Active</option>
                    <option value="inactive">Inactive</option>
                  </select>
                </div>
                <div className="name">
                  <label style={{ fontWeight: 'bold' }}>
                    OTP Verification Days
                  </label>
                  <input
                    type="number"
                    value={form.verificationIntervalDays}
                    onChange={(e) => setForm({ ...form, verificationIntervalDays: e.target.value })}
                    placeholder="Enter number of days..."
                    min="1"
                    style={{ width: "100%", marginTop: "10px", padding: "12px" }}
                  />
                  <small style={{ color: '#666', display: 'block', marginTop: '5px' }}>
                    Number of days before OTP verification is required
                  </small>
                </div>

              </div>

              <div style={{ display: "flex", justifyContent: "flex-end", marginTop: "16px" }}>
                <button
                  type="submit"
                  className="commonButton"
                  disabled={isPending}
                >
                  {isPending ? "Updating..." : "Update User"}
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default EditUsers;
